// material-ui
import { useTheme, styled } from "@mui/material/styles";
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";

// project imports
import MainCard from "@stories/ui-component/cards/MainCard";
import { useNavigate } from "react-router-dom";

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
  overflow: "hidden",
  position: "relative",
  //   "&:after": {
  //     content: '""',
  //     position: "absolute",
  //     width: 210,
  //     height: 210,
  //     background: `linear-gradient(210.04deg, ${theme.palette.primary.main} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
  //     borderRadius: "50%",
  //     top: -30,
  //     right: -180,
  //   },
  //   "&:before": {
  //     content: '""',
  //     position: "absolute",
  //     width: 210,
  //     height: 210,
  //     background: `linear-gradient(140.9deg, ${theme.palette.primary.main} -14.02%, rgba(144, 202, 249, 0) 70.50%)`,
  //     borderRadius: "50%",
  //     top: -160,
  //     right: -130,
  //   },
}));

// ==============================|| DASHBOARD - TOTAL INCOME LIGHT CARD ||============================== //

interface DashboardCardProps {
  title: string;
  subTitle: string;
  link: string;
  icon: React.ReactNode;
}

const DashboardCard = ({ title, subTitle, link, icon }: DashboardCardProps) => {
  const theme = useTheme();

  const navigate = useNavigate();
  return (
    <CardWrapper border={false} content={false}>
      <Box
        sx={{ p: 2, width: "20vw", cursor: "pointer" }}
        onClick={() => {
          navigate(link);
        }}
      >
        <List sx={{ py: 0 }}>
          <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
            <ListItemText
              sx={{
                py: 0,
                mt: 0.45,
                mb: 0.45,
              }}
              primary={<Typography variant="subtitle2">{title}</Typography>}
              secondary={
                <Typography
                  variant="h4"
                  sx={{
                    color: theme.palette.grey[500],
                    mt: 0.5,
                  }}
                >
                  {subTitle}
                </Typography>
              }
            />
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                sx={{
                  ...theme.typography.commonAvatar,
                  ...theme.typography.largeAvatar,
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.dark.main
                      : theme.palette.secondary.light,
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.warning.dark
                      : theme.palette.primary.dark,
                }}
              >
                {icon}
              </Avatar>
            </ListItemAvatar>
          </ListItem>
        </List>
      </Box>
    </CardWrapper>
  );
};

export default DashboardCard;
